import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, DialogTitle, IconButton } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';

import { CloseIconWrapperProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const CloseIconWrapper: React.FC<CloseIconWrapperProps> = (props) => {
  // ======================= HOOKS

  const {
    title,
    onClose,
    footerButton,
    renderFooter,
    children,
    contentProps,
    titleProps,
  } = props;

  // ======================= RENDER FUNCTIONS
  const renderFooterView = () => {
    if (renderFooter) return renderFooter;

    const primary = footerButton?.primary;
    const secondary = footerButton?.secondary;
    return (
      <>
        <Button
          sx={{
            width: '50%',
            fontSize: '16px',
            textTransform: 'none',
            borderRadius: '0px',
          }}
          color={'secondary'}
          variant="outlined"
          onClick={secondary?.onClick}
          {...secondary?.props}
        >
          {secondary?.label ?? 'Reset'}
        </Button>
        <Button
          sx={{
            width: '50%',
            fontSize: '16px',
            textTransform: 'none',
            borderRadius: '0px',
          }}
          color="secondary"
          variant="contained"
          onClick={primary?.onClick}
          {...primary?.props}
        >
          {primary?.label ?? 'Apply'}
        </Button>
      </>
    );
  };
  // ======================= VIEWS
  return (
    <Box sx={{ height: '100%', position: 'relative', display: 'contents' }}>
      <DialogTitle
        {...titleProps}
        sx={{
          padding: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '20px',
          fontWeight: 700,
          lineHeight: '24px',
          textAlign: 'center',
          position: 'sticky',
          top: 0,
          zIndex: 1,
          borderBottom: '1px solid',
          borderColor: 'divider',
          background: 'white',
          ...titleProps?.sx,
        }}
      >
        {title}
        <Box
          sx={{
            position: 'absolute',
            top: 16,
            right: 16,
          }}
        >
          <IconButton
            onClick={onClose}
            edge="end"
            size="small"
            style={{
              color: '#1E242F',
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent
        {...contentProps}
        sx={{
          '::-webkit-scrollbar': {
            width: '6px',
          },
          '::-webkit-scrollbar-thumb': {
            backgroundColor: '#31ACBF',
            borderRadius: '50px',
          },
          ...contentProps?.sx,
        }}
      >
        {children}
      </DialogContent>
      <Stack direction="row" sx={{ position: 'sticky', bottom: 0 }}>
        {renderFooterView()}
      </Stack>
    </Box>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default CloseIconWrapper;
